import type { SVGProps } from "react";

export function IconPurpleDollarCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.9998 51.3334C40.8865 51.3334 51.3332 40.8867 51.3332 28C51.3332 15.1134 40.8865 4.66669 27.9998 4.66669C15.1132 4.66669 4.6665 15.1134 4.6665 28C4.6665 40.8867 15.1132 51.3334 27.9998 51.3334Z"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 19.8333C33.4017 18.235 30.5869 17.1233 28 17.0537M21 35C22.5038 37.005 25.2998 38.1486 28 38.2456M28 17.0537C24.922 16.9708 22.1667 18.3633 22.1667 22.1667C22.1667 29.1666 35 25.6667 35 32.6667C35 36.6591 31.5844 38.3744 28 38.2456M28 17.0537V12.8333M28 38.2456V43.1666"
        stroke="#2E2E2E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
